import { Component } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import 'array-flat-polyfill';
import AppRouter from './route.js';
import store from './store';
import theme from './theme';
import AntDesignTheme from './theme/antDesignTheme';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProductTypeProvider } from './contexts/ProductTypeContext';

class App extends Component {
  render() {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // Time before stale data is refetched
          staleTime: 1000 * 60 * 5, // 5 minutes (can be overridden on a per-query basis)
          // Time before unused data is garbage collected
          gcTime: 'infinity'
        }
      }
    });

    return (
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <ConfigProvider theme={AntDesignTheme}>
              <ProductTypeProvider>
                <AppRouter />
              </ProductTypeProvider>
            </ConfigProvider>
          </ThemeProvider>
        </Provider>
      </QueryClientProvider>
    );
  }
}

export default App;
